import { isSupportedCountry } from "libphonenumber-js/max"

import { IconName } from "@/assets/icons"

export const US_LOCALE = "en-US"

export const LANGUAGE_NAMES = {
  aa: "Afaraf",
  ab: "аҧсуа",
  ae: "avesta", // (Avestan)
  af: "Afrikaans",
  ak: "Akan",
  am: "አማርኛ",
  an: "aragonés",
  ar: "العربية",
  as: "অসমীয়া",
  av: "авар",
  ay: "aymar aru",
  az: "azərbaycan dili",
  ba: "башҡортса",
  be: "Беларуская",
  bg: "български",
  bh: "भोजपुरी",
  bi: "Bislama",
  bm: "bamanankan",
  bn: "বাংলা",
  bo: "བོད་སྐད་",
  br: "brezhoneg",
  bs: "bosanski",
  ca: "català",
  ce: "нохчийн мотт",
  ch: "Chamoru",
  co: "corsu",
  cr: "Nehiyaw",
  cs: "čeština",
  cu: "ѩзыкъ словѣньскъ", // (Church Slavonic)
  cv: "чӑваш чӗлхи",
  cy: "Cymraeg",
  da: "dansk",
  de: "Deutsch",
  dv: "ދިވެހި",
  dz: "རྫོང་ཁ",
  ee: "Eʋegbe",
  el: "ελληνικά",
  en: "English",
  eo: "Esperanto",
  es: "español",
  et: "eesti",
  eu: "euskara",
  fa: "فارسی",
  ff: "pulaar", // or Fulfulde variants
  fi: "suomi",
  fj: "vosa Vakaviti",
  fo: "føroyskt",
  fr: "français",
  fy: "Frysk",
  ga: "Gaeilge",
  gd: "Gàidhlig",
  gl: "galego",
  gn: "Avañe'ẽ",
  gu: "ગુજરાતી",
  gv: "Gaelg",
  ha: "Hausa", // Often used in Latin; some communities also use Arabic script
  he: "עברית",
  hi: "हिन्दी",
  ho: "Hiri Motu",
  hr: "hrvatski",
  ht: "Kreyòl ayisyen",
  hu: "magyar",
  hy: "հայերեն",
  hz: "Otjiherero",
  ia: "Interlingua",
  id: "Bahasa Indonesia",
  ie: "Interlingue",
  ig: "Asụsụ Igbo",
  ii: "ꆈꌠ꒿ Nuosuhxop",
  ik: "Iñupiaq",
  io: "Ido",
  is: "íslenska",
  it: "italiano",
  iu: "ᐃᓄᒃᑎᑐᑦ",
  ja: "日本語",
  jv: "basa Jawa",
  ka: "ქართული",
  kg: "kiKongo",
  ki: "Gikuyu",
  kj: "Kuanyama",
  kk: "қазақ тілі",
  kl: "kalaallisut",
  km: "ភាសាខ្មែរ",
  kn: "ಕನ್ನಡ",
  ko: "한국어",
  kr: "Kanuri",
  ks: "کٲشُر", // Kashmiri (in Perso-Arabic script)
  ku: "Kurdî",
  kv: "коми кыв",
  kw: "Kernewek",
  ky: "Кыргызча",
  la: "latina",
  lb: "Lëtzebuergesch",
  lg: "Luganda",
  li: "Limburgs",
  ln: "lingála",
  lo: "ພາສາລາວ",
  lt: "lietuvių",
  lu: "Tshiluba",
  lv: "latviešu",
  mg: "fiteny malagasy",
  mh: "Kajin M̧ajeļ",
  mi: "te reo Māori",
  mk: "македонски",
  ml: "മലയാളം",
  mn: "монгол",
  mr: "मराठी",
  ms: "Bahasa Melayu",
  mt: "Malti",
  my: "ဗမာစာ",
  na: "Ekakairũ Naoero",
  nb: "norsk bokmål",
  nd: "isiNdebele",
  ne: "नेपाली",
  ng: "Ndonga",
  nl: "Nederlands",
  nn: "nynorsk",
  no: "norsk",
  nr: "isiNdebele",
  nv: "Diné bizaad",
  ny: "chiCheŵa",
  oc: "lenga d'òc",
  oj: "ᐊᓂᔑᓈᐯᒧᐎᓐ",
  om: "Afaan Oromoo",
  or: "ଓଡ଼ିଆ",
  os: "ирон æвзаг",
  pa: "ਪੰਜਾਬੀ",
  pi: "पाळि",
  pl: "polski",
  ps: "پښتو",
  pt: "português",
  qu: "Runa Simi",
  rm: "rumantsch",
  rn: "Ikirundi",
  ro: "română",
  ru: "русский",
  rw: "Kinyarwanda",
  sa: "संस्कृतम्",
  sc: "sardu",
  sd: "سنڌي",
  se: "Davvisámegiella",
  sg: "yângâ tî sängö",
  si: "සිංහල",
  sk: "slovenčina",
  sl: "slovenščina",
  sm: "gagana fa'a Samoa",
  sn: "chiShona",
  so: "Soomaaliga",
  sq: "shqip",
  sr: "српски",
  ss: "SiSwati",
  st: "Sesotho",
  su: "Basa Sunda",
  sv: "svenska",
  sw: "Kiswahili",
  ta: "தமிழ்",
  te: "తెలుగు",
  tg: "тоҷикӣ",
  th: "ไทย",
  ti: "ትግርኛ",
  tk: "Türkmençe",
  tl: "Tagalog",
  tn: "Setswana",
  to: "faka Tonga",
  tr: "Türkçe",
  ts: "Xitsonga",
  tt: "татарча",
  tw: "Twi",
  ty: "Reo Tahiti",
  ug: "ئۇيغۇرچە",
  uk: "українська",
  ur: "اردو",
  uz: "oʻzbek",
  ve: "Tshivenḓa",
  vi: "Tiếng Việt",
  vo: "Volapük",
  wa: "walon",
  wo: "Wolof",
  xh: "isiXhosa",
  yi: "ייִדיש",
  yo: "Èdè Yorùbá",
  za: "Saɯ-cəŋƅ", // approximate local name for Zhuang
  zh: "中文",
  zu: "isiZulu",
} as const

function defineSupportedLanguages<
  T extends readonly (keyof typeof LANGUAGE_NAMES)[],
>(langs: T): T {
  return langs
}

export const SUPPORTED_LANGUAGES = defineSupportedLanguages([
  "en",
  "es",
] as const)

export interface CountryData {
  name: string
  dialCode: string
  iconName: IconName
}

const COUNTRIES_DATA = {
  AX: {
    name: "Åland Islands",
    dialCode: "+358",
    iconName: "flagAalandIslands",
  },
  AF: { name: "Afghanistan", dialCode: "+93", iconName: "flagAfghanistan" },
  AL: { name: "Albania", dialCode: "+355", iconName: "flagAlbania" },
  DZ: { name: "Algeria", dialCode: "+213", iconName: "flagAlgeria" },
  AD: { name: "Andorra", dialCode: "+376", iconName: "flagAndorra" },
  AO: { name: "Angola", dialCode: "+244", iconName: "flagAngola" },
  AG: {
    name: "Antigua and Barbuda",
    dialCode: "+1",
    iconName: "flagAntiguaBarbuda",
  },
  AR: { name: "Argentina", dialCode: "+54", iconName: "flagArgentina" },
  AM: { name: "Armenia", dialCode: "+374", iconName: "flagArmenia" },
  AU: { name: "Australia", dialCode: "+61", iconName: "flagAustralia" },
  AT: { name: "Austria", dialCode: "+43", iconName: "flagAustria" },
  AZ: { name: "Azerbaijan", dialCode: "+994", iconName: "flagAzerbaijan" },
  BS: { name: "Bahamas", dialCode: "+1", iconName: "flagBahamas" },
  BH: { name: "Bahrain", dialCode: "+973", iconName: "flagBahrain" },
  BD: { name: "Bangladesh", dialCode: "+880", iconName: "flagBangladesh" },
  BB: { name: "Barbados", dialCode: "+1", iconName: "flagBarbados" },
  BY: { name: "Belarus", dialCode: "+375", iconName: "flagBelarus" },
  BE: { name: "Belgium", dialCode: "+32", iconName: "flagBelgium" },
  BZ: { name: "Belize", dialCode: "+501", iconName: "flagBelize" },
  BJ: { name: "Benin", dialCode: "+229", iconName: "flagBenin" },
  BT: { name: "Bhutan", dialCode: "+975", iconName: "flagBhutan" },
  BO: { name: "Bolivia", dialCode: "+591", iconName: "flagBolivia" },
  BA: {
    name: "Bosnia and Herzegovina",
    dialCode: "+387",
    iconName: "flagBosniaHerzegovina",
  },
  BW: { name: "Botswana", dialCode: "+267", iconName: "flagBotswana" },
  BR: { name: "Brazil", dialCode: "+55", iconName: "flagBrazil" },
  VG: {
    name: "British Virgin Islands",
    dialCode: "+1",
    iconName: "flagBritishVirginIslands",
  },
  BN: { name: "Brunei", dialCode: "+673", iconName: "flagBrunei" },
  BG: { name: "Bulgaria", dialCode: "+359", iconName: "flagBulgaria" },
  BF: { name: "Burkina Faso", dialCode: "+226", iconName: "flagBurkinaFaso" },
  BI: { name: "Burundi", dialCode: "+257", iconName: "flagBurundi" },
  KH: { name: "Cambodia", dialCode: "+855", iconName: "flagCambodia" },
  CM: { name: "Cameroon", dialCode: "+237", iconName: "flagCameroon" },
  CA: { name: "Canada", dialCode: "+1", iconName: "flagCanada" },
  CV: { name: "Cape Verde", dialCode: "+238", iconName: "flagCapeVerde" },
  KY: { name: "Cayman Islands", dialCode: "+1", iconName: "flagCaymanIslands" },
  CF: {
    name: "Central African Republic",
    dialCode: "+236",
    iconName: "flagCentralAfricanRepublic",
  },
  TD: { name: "Chad", dialCode: "+235", iconName: "flagChad" },
  CL: { name: "Chile", dialCode: "+56", iconName: "flagChile" },
  CN: { name: "China", dialCode: "+86", iconName: "flagChina" },
  CO: { name: "Colombia", dialCode: "+57", iconName: "flagColombia" },
  KM: { name: "Comoros", dialCode: "+269", iconName: "flagComoros" },
  CR: { name: "Costa Rica", dialCode: "+506", iconName: "flagCostaRica" },
  HR: { name: "Croatia", dialCode: "+385", iconName: "flagCroatia" },
  CU: { name: "Cuba", dialCode: "+53", iconName: "flagCuba" },
  CY: { name: "Cyprus", dialCode: "+357", iconName: "flagCyprus" },
  CZ: { name: "Czech Republic", dialCode: "+420", iconName: "flagCzechia" },
  CD: {
    name: "Democratic Republic of the Congo",
    dialCode: "+243",
    iconName: "flagDemocraticRepublicCongo",
  },
  DK: { name: "Denmark", dialCode: "+45", iconName: "flagDenmark" },
  DJ: { name: "Djibouti", dialCode: "+253", iconName: "flagDjibouti" },
  DM: { name: "Dominica", dialCode: "+1", iconName: "flagDominica" },
  DO: {
    name: "Dominican Republic",
    dialCode: "+1",
    iconName: "flagDominicanRepublic",
  },
  TL: { name: "East Timor", dialCode: "+670", iconName: "flagEastTimor" },
  EC: { name: "Ecuador", dialCode: "+593", iconName: "flagEcuador" },
  EG: { name: "Egypt", dialCode: "+20", iconName: "flagEgypt" },
  SV: { name: "El Salvador", dialCode: "+503", iconName: "flagElSalvador" },
  GQ: {
    name: "Equatorial Guinea",
    dialCode: "+240",
    iconName: "flagEquatorialGuinea",
  },
  ER: { name: "Eritrea", dialCode: "+291", iconName: "flagEritrea" },
  EE: { name: "Estonia", dialCode: "+372", iconName: "flagEstonia" },
  ET: { name: "Ethiopia", dialCode: "+251", iconName: "flagEthiopia" },
  FK: {
    name: "Falkland Islands",
    dialCode: "+500",
    iconName: "flagFalklandIslands",
  },
  FO: { name: "Faroe Islands", dialCode: "+298", iconName: "flagFaroeIslands" },
  FJ: { name: "Fiji", dialCode: "+679", iconName: "flagFiji" },
  FI: { name: "Finland", dialCode: "+358", iconName: "flagFinland" },
  FR: { name: "France", dialCode: "+33", iconName: "flagFrance" },
  GF: { name: "French Guiana", dialCode: "+594", iconName: "flagFrenchGuiana" },
  GA: { name: "Gabon", dialCode: "+241", iconName: "flagGabon" },
  GM: { name: "Gambia", dialCode: "+220", iconName: "flagGambia" },
  GE: { name: "Georgia", dialCode: "+995", iconName: "flagGeorgia" },
  DE: { name: "Germany", dialCode: "+49", iconName: "flagGermany" },
  GH: { name: "Ghana", dialCode: "+233", iconName: "flagGhana" },
  GI: { name: "Gibraltar", dialCode: "+350", iconName: "flagGibraltar" },
  GR: { name: "Greece", dialCode: "+30", iconName: "flagGreece" },
  GD: { name: "Grenada", dialCode: "+1", iconName: "flagGrenada" },
  GP: { name: "Guadeloupe", dialCode: "+590", iconName: "flagGuadeloupe" },
  GT: { name: "Guatemala", dialCode: "+502", iconName: "flagGuatemala" },
  GG: { name: "Guernsey", dialCode: "+44", iconName: "flagGuernsey" },
  GN: { name: "Guinea", dialCode: "+224", iconName: "flagGuinea" },
  GY: { name: "Guyana", dialCode: "+592", iconName: "flagGuyana" },
  HT: { name: "Haiti", dialCode: "+509", iconName: "flagHaiti" },
  HN: { name: "Honduras", dialCode: "+504", iconName: "flagHonduras" },
  HK: { name: "Hong Kong", dialCode: "+852", iconName: "flagHongKong" },
  HU: { name: "Hungary", dialCode: "+36", iconName: "flagHungary" },
  IS: { name: "Iceland", dialCode: "+354", iconName: "flagIceland" },
  IN: { name: "India", dialCode: "+91", iconName: "flagIndia" },
  ID: { name: "Indonesia", dialCode: "+62", iconName: "flagIndonesia" },
  IR: { name: "Iran", dialCode: "+98", iconName: "flagIran" },
  IQ: { name: "Iraq", dialCode: "+964", iconName: "flagIraq" },
  IE: { name: "Ireland", dialCode: "+353", iconName: "flagIreland" },
  IM: { name: "Isle of Man", dialCode: "+44", iconName: "flagIsleOfMan" },
  IL: { name: "Israel", dialCode: "+972", iconName: "flagIsrael" },
  IT: { name: "Italy", dialCode: "+39", iconName: "flagItaly" },
  CI: { name: "Ivory Coast", dialCode: "+225", iconName: "flagIvoryCoast" },
  JM: { name: "Jamaica", dialCode: "+1", iconName: "flagJamaica" },
  JP: { name: "Japan", dialCode: "+81", iconName: "flagJapan" },
  JE: { name: "Jersey", dialCode: "+44", iconName: "flagJersey" },
  JO: { name: "Jordan", dialCode: "+962", iconName: "flagJordan" },
  KZ: { name: "Kazakhstan", dialCode: "+7", iconName: "flagKazakhstan" },
  KE: { name: "Kenya", dialCode: "+254", iconName: "flagKenya" },
  KI: { name: "Kiribati", dialCode: "+686", iconName: "flagKiribati" },
  XK: { name: "Kosovo", dialCode: "+383", iconName: "flagKosovo" },
  KW: { name: "Kuwait", dialCode: "+965", iconName: "flagKuwait" },
  KG: { name: "Kyrgyzstan", dialCode: "+996", iconName: "flagKyrgyzstan" },
  LA: { name: "Laos", dialCode: "+856", iconName: "flagLaos" },
  LV: { name: "Latvia", dialCode: "+371", iconName: "flagLatvia" },
  LB: { name: "Lebanon", dialCode: "+961", iconName: "flagLebanon" },
  LS: { name: "Lesotho", dialCode: "+266", iconName: "flagLesotho" },
  LR: { name: "Liberia", dialCode: "+231", iconName: "flagLiberia" },
  LY: { name: "Libya", dialCode: "+218", iconName: "flagLibya" },
  LI: {
    name: "Liechtenstein",
    dialCode: "+423",
    iconName: "flagLiechtenstein",
  },
  LT: { name: "Lithuania", dialCode: "+370", iconName: "flagLithuania" },
  LU: { name: "Luxembourg", dialCode: "+352", iconName: "flagLuxembourg" },
  MG: { name: "Madagascar", dialCode: "+261", iconName: "flagMadagascar" },
  MW: { name: "Malawi", dialCode: "+265", iconName: "flagMalawi" },
  MY: { name: "Malaysia", dialCode: "+60", iconName: "flagMalaysia" },
  MV: { name: "Maldives", dialCode: "+960", iconName: "flagMaldives" },
  ML: { name: "Mali", dialCode: "+223", iconName: "flagMali" },
  MT: { name: "Malta", dialCode: "+356", iconName: "flagMalta" },
  MH: {
    name: "Marshall Islands",
    dialCode: "+692",
    iconName: "flagMarshallIslands",
  },
  MR: { name: "Mauritania", dialCode: "+222", iconName: "flagMauritania" },
  MU: { name: "Mauritius", dialCode: "+230", iconName: "flagMauritius" },
  MX: { name: "Mexico", dialCode: "+52", iconName: "flagMexico" },
  FM: { name: "Micronesia", dialCode: "+691", iconName: "flagMicronesia" },
  MD: { name: "Moldova", dialCode: "+373", iconName: "flagMoldova" },
  MC: { name: "Monaco", dialCode: "+377", iconName: "flagMonaco" },
  MN: { name: "Mongolia", dialCode: "+976", iconName: "flagMongolia" },
  ME: { name: "Montenegro", dialCode: "+382", iconName: "flagMontenegro" },
  MA: { name: "Morocco", dialCode: "+212", iconName: "flagMorocco" },
  MZ: { name: "Mozambique", dialCode: "+258", iconName: "flagMozanbique" },
  MM: { name: "Myanmar", dialCode: "+95", iconName: "flagMyanmar" },
  NA: { name: "Namibia", dialCode: "+264", iconName: "flagNamibia" },
  NR: { name: "Nauru", dialCode: "+674", iconName: "flagNauru" },
  NP: { name: "Nepal", dialCode: "+977", iconName: "flagNepal" },
  NL: { name: "Netherlands", dialCode: "+31", iconName: "flagNetherlands" },
  NZ: { name: "New Zealand", dialCode: "+64", iconName: "flagNewZealand" },
  NI: { name: "Nicaragua", dialCode: "+505", iconName: "flagNicaragua" },
  NE: { name: "Niger", dialCode: "+227", iconName: "flagNiger" },
  NG: { name: "Nigeria", dialCode: "+234", iconName: "flagNigeria" },
  KP: { name: "North Korea", dialCode: "+850", iconName: "flagNorthKorea" },
  MK: {
    name: "North Macedonia",
    dialCode: "+389",
    iconName: "flagNorthMacedonia",
  },
  NO: { name: "Norway", dialCode: "+47", iconName: "flagNorway" },
  OM: { name: "Oman", dialCode: "+968", iconName: "flagOman" },
  PK: { name: "Pakistan", dialCode: "+92", iconName: "flagPakistan" },
  PW: { name: "Palau", dialCode: "+680", iconName: "flagPalau" },
  PS: { name: "Palestine", dialCode: "+970", iconName: "flagPalestine" },
  PA: { name: "Panama", dialCode: "+507", iconName: "flagPanama" },
  PG: {
    name: "Papua New Guinea",
    dialCode: "+675",
    iconName: "flagPapuaNewGuinea",
  },
  PY: { name: "Paraguay", dialCode: "+595", iconName: "flagParaguay" },
  PE: { name: "Peru", dialCode: "+51", iconName: "flagPeru" },
  PH: { name: "Philippines", dialCode: "+63", iconName: "flagPhilippines" },
  PL: { name: "Poland", dialCode: "+48", iconName: "flagPoland" },
  PT: { name: "Portugal", dialCode: "+351", iconName: "flagPortugal" },
  PR: { name: "Puerto Rico", dialCode: "+1", iconName: "flagPuertoRico" },
  QA: { name: "Qatar", dialCode: "+974", iconName: "flagQuatar" },
  CG: {
    name: "Republic of the Congo",
    dialCode: "+242",
    iconName: "flagRepublicCongo",
  },
  RO: { name: "Romania", dialCode: "+40", iconName: "flagRomania" },
  RU: { name: "Russia", dialCode: "+7", iconName: "flagRussia" },
  RW: { name: "Rwanda", dialCode: "+250", iconName: "flagRwanda" },
  KN: {
    name: "Saint Kitts and Nevis",
    dialCode: "+1",
    iconName: "flagSaintKittsNevis",
  },
  LC: { name: "Saint Lucia", dialCode: "+1", iconName: "flagSaintLucia" },
  VC: {
    name: "Saint Vincent and the Grenadines",
    dialCode: "+1",
    iconName: "flagSaintVincentGrenadines",
  },
  WS: { name: "Samoa", dialCode: "+685", iconName: "flagSamoa" },
  SM: { name: "San Marino", dialCode: "+378", iconName: "flagSanMarino" },
  ST: {
    name: "Sao Tome and Principe",
    dialCode: "+239",
    iconName: "flagSaoTomePrincipe",
  },
  SA: { name: "Saudi Arabia", dialCode: "+966", iconName: "flagSaudiArabia" },
  SN: { name: "Senegal", dialCode: "+221", iconName: "flagSenegal" },
  RS: { name: "Serbia", dialCode: "+381", iconName: "flagSerbia" },
  SC: { name: "Seychelles", dialCode: "+248", iconName: "flagSeychelles" },
  SL: { name: "Sierra Leone", dialCode: "+232", iconName: "flagSierraLeone" },
  SG: { name: "Singapore", dialCode: "+65", iconName: "flagSingapore" },
  SK: { name: "Slovakia", dialCode: "+421", iconName: "flagSlovakia" },
  SI: { name: "Slovenia", dialCode: "+386", iconName: "flagSlovenia" },
  SB: {
    name: "Solomon Islands",
    dialCode: "+677",
    iconName: "flagSolomonIslands",
  },
  SO: { name: "Somalia", dialCode: "+252", iconName: "flagSomalia" },
  ZA: { name: "South Africa", dialCode: "+27", iconName: "flagSouthAfrica" },
  GS: {
    name: "South Georgia and the South Sandwich Islands",
    dialCode: "+500",
    iconName: "flagSouthGeorgiaSandwichIslands",
  },
  KR: { name: "South Korea", dialCode: "+82", iconName: "flagSouthKorea" },
  SS: { name: "South Sudan", dialCode: "+211", iconName: "flagSouthSudan" },
  ES: { name: "Spain", dialCode: "+34", iconName: "flagSpain" },
  LK: { name: "Sri Lanka", dialCode: "+94", iconName: "flagSriLanka" },
  SD: { name: "Sudan", dialCode: "+249", iconName: "flagSudan" },
  SR: { name: "Suriname", dialCode: "+597", iconName: "flagSuriname" },
  SE: { name: "Sweden", dialCode: "+46", iconName: "flagSweden" },
  CH: { name: "Switzerland", dialCode: "+41", iconName: "flagSwitzerland" },
  SY: { name: "Syria", dialCode: "+963", iconName: "flagSyria" },
  TW: { name: "Taiwan", dialCode: "+886", iconName: "flagTaiwan" },
  TJ: { name: "Tajikistan", dialCode: "+992", iconName: "flagTajikistan" },
  TZ: { name: "Tanzania", dialCode: "+255", iconName: "flagTanzania" },
  TH: { name: "Thailand", dialCode: "+66", iconName: "flagThailand" },
  TG: { name: "Togo", dialCode: "+228", iconName: "flagTogo" },
  TO: { name: "Tonga", dialCode: "+676", iconName: "flagTonga" },
  TT: {
    name: "Trinidad and Tobago",
    dialCode: "+1",
    iconName: "flagTrinidadTobago",
  },
  TN: { name: "Tunisia", dialCode: "+216", iconName: "flagTunisia" },
  TR: { name: "Turkey", dialCode: "+90", iconName: "flagTurkey" },
  TM: { name: "Turkmenistan", dialCode: "+993", iconName: "flagTurkmenistan" },
  UG: { name: "Uganda", dialCode: "+256", iconName: "flagUganda" },
  UA: { name: "Ukraine", dialCode: "+380", iconName: "flagUkraine" },
  AE: {
    name: "United Arab Emirates",
    dialCode: "+971",
    iconName: "flagUnitedArabEmirates",
  },
  GB: {
    name: "United Kingdom",
    dialCode: "+44",
    iconName: "flagUnitedKingdom",
  },
  US: { name: "United States", dialCode: "+1", iconName: "flagUnitedStates" },
  UY: { name: "Uruguay", dialCode: "+598", iconName: "flagUruguay" },
  UZ: { name: "Uzbekistan", dialCode: "+998", iconName: "flagUzbekistan" },
  VE: { name: "Venezuela", dialCode: "+58", iconName: "flagVenezuela" },
  VN: { name: "Vietnam", dialCode: "+84", iconName: "flagVietnam" },
  YE: { name: "Yemen", dialCode: "+967", iconName: "flagYemen" },
  ZM: { name: "Zambia", dialCode: "+260", iconName: "flagZambia" },
  ZW: { name: "Zimbabwe", dialCode: "+263", iconName: "flagZimbabwe" },
} as const satisfies Record<string, CountryData>

export type CountryIdentifiers = keyof typeof COUNTRIES_DATA

export const COUNTRIES: ReadonlyMap<CountryIdentifiers, CountryData> = new Map(
  Object.entries(COUNTRIES_DATA) as ReadonlyArray<
    readonly [CountryIdentifiers, CountryData]
  >
)

export interface CountryPhoneData {
  code: CountryIdentifiers
  name: string
  dialCode: string
  iconName?: IconName
}

export function getCountriesWithPhoneData(): CountryPhoneData[] {
  const countries: CountryPhoneData[] = []

  for (const [code, data] of COUNTRIES.entries()) {
    if (!isSupportedCountry(code)) continue

    countries.push({
      code,
      name: data.name,
      dialCode: data.dialCode,
      iconName: data.iconName,
    })
  }

  return countries.sort((a, b) => a.name.localeCompare(b.name))
}

function isCountryIdentifier(code: string): code is CountryIdentifiers {
  return code in COUNTRIES_DATA
}

// Accepts any string (e.g. an ISO code from libphonenumber); the type guard
// narrows it to a known identifier before the lookup.
export function getCountryPhoneData(
  code: string
): CountryPhoneData | undefined {
  if (!isCountryIdentifier(code)) return undefined

  const data = COUNTRIES.get(code)
  if (data) {
    return {
      code,
      name: data.name,
      dialCode: data.dialCode,
      iconName: data.iconName,
    }
  }
  return undefined
}

export function searchCountriesForPhone(query: string): CountryPhoneData[] {
  const lowerQuery = query.toLowerCase()
  return getCountriesWithPhoneData().filter(
    (country) =>
      country.name.toLowerCase().includes(lowerQuery) ||
      country.code.toLowerCase().includes(lowerQuery) ||
      country.dialCode.includes(query)
  )
}

type LanguageIdentifier = (typeof SUPPORTED_LANGUAGES)[number] | (string & {})

export function iconForLanguage(
  languageIdentifier?: LanguageIdentifier
): IconName {
  switch (languageIdentifier) {
    case "en":
      return COUNTRIES.get("US")!.iconName
    case "es":
      return COUNTRIES.get("MX")!.iconName
    default:
      return "translation"
  }
}

export function getLanguageName(languageIdentifier?: LanguageIdentifier) {
  if (languageIdentifier && languageIdentifier in LANGUAGE_NAMES) {
    return LANGUAGE_NAMES[languageIdentifier as keyof typeof LANGUAGE_NAMES]
  }
  return "English"
}

export function getCountryCodesFromPhoneNumber(
  phoneNumber: string
): CountryIdentifiers[] {
  // Normalize the phone number - remove spaces, dashes, parentheses
  const normalized = phoneNumber.replace(/[\s\-()]/g, "")

  // Ensure it starts with + for consistent matching
  const withPlus = normalized.startsWith("+") ? normalized : `+${normalized}`

  const countryMatches: CountryIdentifiers[] = []
  COUNTRIES.forEach((countryData, countryCode) => {
    if (withPlus.startsWith(countryData.dialCode)) {
      countryMatches.push(countryCode)
    }
  })

  return countryMatches
}
